import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import FavoriteIcon from "../../../assets/images/blue-favorite-icon.svg";
import LaterIcon from "../../../assets/images/blue-later-icon.svg";
import LearningIcon from "../../../assets/images/blue-learning.svg";
import PlaylistIcon from "../../../assets/images/blue-playlist-icon.svg";
import ShareIcon from "../../../assets/images/blue-share-icon.svg";
import useUserInfo from '../../../hooks/useUserInfo';
import { addContentToList } from "../../../redux/action-creators/learningList";
import { addFavorite } from "../../../redux/actions/favorite";
import BluePopUp from "../../global/BluePopUp/BluePopUp";
import ContentIcon from "../ContentIcon/ContentIcon";
import AddInCollectionPopUp from "./AddInCollectionPopUp/AddInCollectionPopUp";
import "./ContentIconList.scss";
import IsFetchingIcon from "./IsFetchingIcon/IsFetchingIcon";

const ContentIconList = () => {
  const history = useHistory();
  const content = useSelector(state => state.content);
  const learningList = useSelector(state => state.learningList.list);
  const favorite = useSelector(state => state.favorite);
  const seeLater = useSelector(state => state.seeLater);
  const [openBluePopJourney, setOpenBluePopJourney] = useState(false);
  const [openBluePopJourneyMessage, setOpenBluePopJourneyMessage] = useState("");
  const [openAddJourney, setOpenAddJourney] = useState(false);
  const [openFavoritePopUp, setOpenFavoritePopUp] = useState(false);
  const [favoriteMessage, setFavoriteMessage] = useState("");
  const [OpenSeeLaterPopUp, setOpenSeeLaterPopUp] = useState(false);
  const [seeLaterMessage, setSeeLaterMessage] = useState("");
  const [openSharePopUp, setOpenSharePopUp] = useState(false);
  const [openLearningPopUp, setOpenLearningPopUp] = useState(false);
  const [learningMessage, setLearningMessage] = useState("");
  const { contentId } = useParams();
  const dispatch = useDispatch();
  const { userInfo, isLoggedIn } = useUserInfo();

  const addContentInFavorite = e => {
    e.preventDefault()
    const payload = {
      platform: "ALEXANDRIA"
    }
    dispatch(addFavorite(contentId, payload))
      .then(() => {
        setOpenFavoritePopUp(true)
        setFavoriteMessage("Conteúdo adicionado aos itens favoritos")
      })
      .catch(() => {
        setOpenFavoritePopUp(true)
        setFavoriteMessage("")
      });
  }

  const addContentInSeeLater = e => {
    e.preventDefault()
    const payload = {
      platform: "ALEXANDRIA"
    }
    dispatch(addFavorite(contentId, payload))
      .then(() => {
        setOpenSeeLaterPopUp(true)
        setSeeLaterMessage(`Conteúdo adicionado ao "Ver Mais Tarde"`)
      })
      .catch(() => {
        setOpenSeeLaterPopUp(true)
        setSeeLaterMessage("")
      });
  }

  const copyToLinkShare = () => {
    let textField = document.createElement('textarea')
    textField.innerText = window.location.href;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setOpenSharePopUp(true)
  }

  const addLearningList = (e) => {
    const hasContent = learningList.filter((itemList) => itemList.id === content.data.id);
    if (Object.keys(content.data).length > 0 && hasContent.length === 0) {
      dispatch(addContentToList(content.data))
      setOpenLearningPopUp(true)
      setLearningMessage("Conteúdo adicionado a lista de aprendizado")
    } else {
      setOpenLearningPopUp(true)
      setLearningMessage("Você já possui este conteúdo na lista")
    }
  }
  return (
    <div className="ContentIconList">
      <div className="list-title">
        <p>HOME/ARTIGO/<strong>CONTEÚDO</strong></p>
      </div>
      {favorite?.isFetching ? <IsFetchingIcon /> : <ContentIcon
        textButton="favoritar"
        urlButton={FavoriteIcon}
        onClick={(e) => {
          isLoggedIn && userInfo.username ? addContentInFavorite(e) : history.push("/login")
        }} />}
      {seeLater?.isFetching ? <IsFetchingIcon /> : <ContentIcon
        textButton="ver mais tarde"
        urlButton={LaterIcon}
        onClick={(e) => {
          isLoggedIn && userInfo.username ? addContentInSeeLater(e) : history.push("/login")
        }} />}
      <ContentIcon textButton="adicionar a playlist" urlButton={PlaylistIcon} onClick={() =>
        isLoggedIn && userInfo.username ? setOpenAddJourney(true) : history.push("/login")
      } />
      <ContentIcon textButton="lista de aprendizado" urlButton={LearningIcon} onClick={(e) =>
        isLoggedIn && userInfo.username ? addLearningList(e) : history.push("/login")
      } />
      <ContentIcon textButton="compartilhar" urlButton={ShareIcon}
        onClick={() => copyToLinkShare()} />
      {openBluePopJourney && <BluePopUp text={openBluePopJourneyMessage} onClick={() => {
        setOpenBluePopJourney(false)
      }} />}
      {openAddJourney && <AddInCollectionPopUp
        setOpenAddJourney={setOpenAddJourney}
        setOpenBluePopJourney={setOpenBluePopJourney}
        setOpenBluePopJourneyMessage={setOpenBluePopJourneyMessage}
        contentID={contentId} />}
      {openFavoritePopUp &&
        <BluePopUp text={favoriteMessage} onClick={() => setOpenFavoritePopUp(false)} />}
      {OpenSeeLaterPopUp &&
        <BluePopUp text={seeLaterMessage} onClick={() => setOpenSeeLaterPopUp(false)} />}
      {openSharePopUp &&
        <BluePopUp text="Link copiado para área de transferência" onClick={() => setOpenSharePopUp(false)} />}
      {openLearningPopUp &&
        <BluePopUp text={learningMessage} onClick={() => setOpenLearningPopUp(false)} />}
    </div>
  );
};

export default ContentIconList;
